import React from "react";
import { Col, Row, Typography, Layout, Card } from "antd";
import { Calendar, dayjsLocalizer } from 'react-big-calendar';
import dayjs from "dayjs";
import "react-big-calendar/lib/css/react-big-calendar.css";

function MyCalander() {
const localizer = dayjsLocalizer(dayjs)

  return (
    <Layout style={{ minHeight: "80vh" }}>
      <Row
        className="blueBackground"
        style={{
          height: "45vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography.Title
          className="fontFamily1"
          style={{ fontSize: "30px", color: "#333d47" }}
        >
          {<>My Calender</>}
        </Typography.Title>
      </Row>

      {/* section 2 */}
      <Row
        className="whiteBackground"
        style={{ backgroundColor: "white", justifyContent: "center" }}
      >
        <Col xs={24} md={20}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",

              padding: "50px 20px",
            }}
          >
            <Card
              className="infoBox"
              bordered={false}
              style={{
                width: "100%",
                padding: "20px",
              }}
            >
            <Calendar
      localizer={localizer}
      events={[
        { title: 'event 1', start: new Date() , end: new Date() },
        { title: 'event 2', start: new Date() , end: new Date() }
      
      ]}
      startAccessor="start"
      endAccessor="end"
      style={{ height: 700 }}
    />
            </Card>
          </div>
        </Col>
      </Row>
    </Layout>
  );
}

export default MyCalander;
